/**
 * TermsAndConditions — public, no-login page linked from the booking-form SMS opt-in checkbox
 * (Twilio Toll-Free Verification 30513 references "Terms and Conditions"). Served at
 * https://slik-pos-public.web.app/terms. Mirrors the SMS-program disclosures in the Privacy Policy.
 */
import React from 'react';

const TermsAndConditions: React.FC = () => (
  <div className="min-h-screen bg-gray-50 py-10 px-4">
    <div className="max-w-2xl mx-auto bg-white rounded-2xl shadow-card p-6 md:p-8 text-gray-800 leading-relaxed">
      <a href="/" className="text-slik-purple text-sm">&larr; Back to SLIK Barber Lounge</a>
      <h1 className="text-2xl font-bold text-slik-navy mt-4 mb-1">Terms &amp; Conditions</h1>
      <p className="text-xs text-gray-400 mb-6">SLIK Barber Lounge &middot; Last updated September 2026</p>

      <p className="mb-4">
        These Terms &amp; Conditions govern your use of SLIK Barber Lounge&rsquo;s booking website and
        services (&ldquo;we,&rdquo; &ldquo;us,&rdquo; &ldquo;our&rdquo;). By booking an appointment or
        using this site, you agree to these terms.
      </p>

      <h2 className="text-lg font-semibold text-slik-navy mt-6 mb-2">Appointments &amp; cancellations</h2>
      <p className="mb-4">
        Appointments are booked in person, by phone, or through this website. Please arrive on time; we
        ask that any cancellation or reschedule be made in advance. Repeated no-shows may require a deposit
        or prepayment to book future appointments.
      </p>

      <h2 className="text-lg font-semibold text-slik-navy mt-6 mb-2">SMS / text messaging program</h2>
      <p className="mb-2">
        When you provide your mobile number and opt in, you agree to receive account and appointment text
        messages from SLIK Barber Lounge &mdash; such as booking confirmations, reminders, receipts,
        rescheduling and waitlist notifications, and &ldquo;on my way&rdquo; updates.
      </p>
      <ul className="list-disc pl-5 mb-4 space-y-1">
        <li>Message frequency may vary based on your appointments and activity.</li>
        <li>Message and data rates may apply.</li>
        <li>Reply <b>HELP</b> for help, or <b>STOP</b> to any message to unsubscribe at any time.</li>
        <li>Consenting to receive texts is <b>not</b> a condition of any purchase or booking.</li>
        <li>
          We do not sell or share your number or opt-in information with third parties for their marketing.
          See our <a href="/privacy" className="text-slik-purple underline">Privacy Policy</a>.
        </li>
      </ul>

      <h2 className="text-lg font-semibold text-slik-navy mt-6 mb-2">Payments</h2>
      <p className="mb-4">
        Payment is due at the time of service unless a deposit or prepayment applies. Prices are subject to
        change. Card payments are handled by our payment processor; we do not store full card numbers.
      </p>

      <h2 className="text-lg font-semibold text-slik-navy mt-6 mb-2">Limitation of liability</h2>
      <p className="mb-4">
        Services are provided as-is. To the fullest extent permitted by law, SLIK Barber Lounge is not
        liable for indirect or incidental damages arising from use of this site or our services.
      </p>

      <h2 className="text-lg font-semibold text-slik-navy mt-6 mb-2">Contact us</h2>
      <p className="mb-1">
        Questions about these terms? Reach SLIK Barber Lounge through our website at{' '}
        <a href="https://slikbarberlounge.com" className="text-slik-purple underline">slikbarberlounge.com</a>,
        or reply to any text message you receive from us.
      </p>
    </div>
  </div>
);

export default TermsAndConditions;
